// import store from 'components/store'
import { AuthProvider } from 'pages/authenticated/AuthContext'
import { PermissionsProvider } from 'pages/authenticated/PermissionsContext'
import ReactDOM from 'react-dom/client'
import './index.css'
import { QueryClient, QueryClientProvider } from 'react-query'

// import { Provider } from 'react-redux'
import "./i18n";
import App from './App'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  // <Provider store={store}>
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <PermissionsProvider>
        <App />
      </PermissionsProvider>
    </AuthProvider>
  </QueryClientProvider>
  // </Provider>
)
